import { useFilterSectionIsShown } from 'components/filter/filters-next/useFilterSectionIsShown';
import { SelectListItemSeparator } from 'components/select';

const FilterListSearchSeparator = () => {
    const isShown = useFilterSectionIsShown();

    if (isShown) {
        return <SelectListItemSeparator />;
    }

    return null;
};

export { FilterListSearchSeparator };
